import { createSelector } from 'reselect';

import getAllSkuData from 'src/selectors/skus/getAllSkuData';
import getSku from './getSku';

const getSkuData = createSelector([getAllSkuData, getSku], (allSkuData, sku) => allSkuData[sku]);

export default getSkuData;
